export default "__VITE_ASSET__B$kcp0HF__"